module.exports = __webpack_public_path__ + "img/electronic_electric_enabled_selected.6b65e0b2.svg";